import React from "react";
import { Check, Apple, Play, QrCode } from "lucide-react";
import { BRAND, APP_FEATURES } from "../mock";
import Reveal from "./Reveal";

const AppDownloadSection = () => (
  <section className="py-16 sm:py-20 bg-gradient-to-br from-[#eef4fb] to-[#fdf3e6]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="bg-navy rounded-3xl overflow-hidden shadow-2xl relative">
        <div className="absolute -top-16 -right-16 w-64 h-64 bg-orange-brand/20 rounded-full blur-3xl" />
        <div className="grid lg:grid-cols-2 gap-8 p-8 sm:p-12 relative">
          <Reveal>
            <h2 className="text-2xl sm:text-3xl font-bold text-orange-brand font-head">Laundry &amp; Dry Clean Made Easy</h2>
            <p className="text-white text-lg mt-1 font-semibold">Download the {BRAND.name} App</p>
            <p className="text-white/70 mt-2">Get {BRAND.discount} OFF on garment cleaning.*</p>
            <ul className="mt-6 space-y-3">
              {APP_FEATURES.map((f) => (
                <li key={f} className="flex items-center gap-3 text-white/90">
                  <span className="w-6 h-6 rounded-full bg-orange-brand/20 flex items-center justify-center"><Check size={15} className="text-orange-brand" /></span>
                  {f}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3 mt-7">
              <a href="#" className="inline-flex items-center gap-3 bg-white text-navy rounded-xl px-5 py-3 hover:bg-gray-50 transition-colors">
                <Apple size={26} />
                <span className="text-left leading-tight"><span className="block text-[10px] text-navy/60">Download on the</span><span className="font-bold">App Store</span></span>
              </a>
              <a href="#" className="inline-flex items-center gap-3 bg-white text-navy rounded-xl px-5 py-3 hover:bg-gray-50 transition-colors">
                <Play size={24} className="fill-navy" />
                <span className="text-left leading-tight"><span className="block text-[10px] text-navy/60">GET IT ON</span><span className="font-bold">Google Play</span></span>
              </a>
            </div>
          </Reveal>
          <Reveal delay={120} className="flex items-center justify-center lg:justify-end">
            <div className="bg-white rounded-2xl p-6 text-center shadow-xl">
              <div className="w-40 h-40 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl flex items-center justify-center mb-3 border border-gray-100">
                <QrCode size={110} className="text-navy" strokeWidth={1} />
              </div>
              <p className="text-navy font-semibold text-sm">Scan to<br />Download App</p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default AppDownloadSection;
